export const ArrowDownCircle = ({ size = 13, color = "currentColor" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8C16 3.58887 12.4111 0 8 0C3.58887 0 0 3.58887 0 8C0 12.4111 3.58887 16 8 16C12.4111 16 16 12.4111 16 8ZM1 8C1 4.14013 4.14013 1 8 1C11.8599 1 15 4.14013 15 8C15 11.8599 11.8599 15 8 15C4.14013 15 1 11.8599 1 8ZM8.3535 11.3535C8.3071 11.4 8.25199 11.4368 8.19134 11.462C8.13068 11.4871 8.06566 11.5 8 11.5C7.93434 11.5 7.86932 11.4871 7.80866 11.462C7.74801 11.4368 7.6929 11.4 7.6465 11.3535L5.1465 8.8535C5.04887 8.75588 5 8.62788 5 8.5C5 8.37212 5.04887 8.24412 5.1465 8.1465C5.1929 8.10004 5.24801 8.06319 5.30866 8.03804C5.36932 8.01289 5.43434 7.99995 5.5 7.99995C5.56566 7.99995 5.63068 8.01289 5.69134 8.03804C5.75199 8.06319 5.8071 8.10004 5.8535 8.1465L7.5 9.793V5C7.5 4.72388 7.72363 4.5 8 4.5C8.27637 4.5 8.5 4.72388 8.5 5L8.5 9.793L10.1465 8.1465C10.3419 7.95112 10.6582 7.95112 10.8535 8.1465C11.0487 8.34188 11.0489 8.65825 10.8535 8.8535L8.3535 11.3535Z"
        fill={color}
      />
    </svg>
  );
};
